import { z } from 'zod';
import { bonusParametersInputSchema, bonusParametersReHydratedItemSchema, bonusParametersReHydratedSchema, bonusParametersSchema } from '../schemas/bonusParametersSchema.js';
// type guards
export function isBonusParametersInput(data: any): data is z.infer<typeof bonusParametersInputSchema> {
    return bonusParametersInputSchema.safeParse(data).success;
}
export function isBonusParameters(data: any): data is z.infer<typeof bonusParametersSchema> {
    return bonusParametersSchema.safeParse(data).success;
}
export type BonusParameters = z.infer<typeof bonusParametersSchema>;
export type BonusParametersInput = z.infer<typeof bonusParametersInputSchema>;
export type BonusParametersReHydratedItem = z.infer<typeof bonusParametersReHydratedItemSchema>;
export type BonusParametersReHydrated =z.infer<typeof bonusParametersReHydratedSchema>;